<div *ngIf="numericAttribute" class="content-subcontainer">
  <div class="content-input">
    <span *ngIf="showLabel"> {{ getLocalizedString(numericAttribute.infoText) }} </span>

    <mat-form-field class="input-select">
      <mat-select (selectionChange)="onInputChange($event)" [value]="current">
          <div *ngFor="let value of possibleValues" matTooltipPosition="right" [matTooltip]="parseReason(checkIfValueCanBeSet(value))" >

            <mat-option [disabled]="!checkIfValueCanBeSet(value).isAvailible" [value]="value" >{{value|unitConversion:unitFactor:unit}}</mat-option>

          </div>


      </mat-select>
    </mat-form-field>


    <button *ngIf="showConfirmButton" class="confirm-numeric-button" mat-button (pointerdown)="confirmInput()">
      <mat-icon> check </mat-icon>
    </button>
  </div>
  <span *ngIf="isInputChanged | async" class="notification-text">{{ 'translations.numeric-input-notification' | translate }}</span>
</div>
